import styled from '@emotion/styled'
import {rhythm} from '../../lib/typography'

export default styled.h3`
  text-align: left;
  margin-top: ${rhythm(2)};
  margin-bottom: ${rhythm(1)};
  font-size: 1.4rem;
  line-height: 1.5;
`
